// extracted by mini-css-extract-plugin
export default {"appInfoContainer":"AppInfo_appInfoContainer__5Jhbq","infoSign":"AppInfo_infoSign__oa4t+","alertInfo":"AppInfo_alertInfo__YFxW0"};